// extracted by mini-css-extract-plugin
module.exports = {"sigBox":"signature_sigBox__2VqvX","preview":"signature_preview__asf32"};